import { type ReactNode } from "react";
import { Slip } from "./Slip";
import { SLIP, type SlipKey } from "./slip-manifest";

/** A page section: just the big Slipstream header + content. No eyebrow label,
 *  no dividers (killed per feedback — kept the header text only). The header is
 *  drawn from public/slip/{id}.svg when the section id has outlines; any other title
 *  falls back to the Orbitron speed-cut. */
export function Section({
  id,
  title,
  children,
}: {
  id: string;
  /** kept for call-site compatibility / anchor semantics; not rendered */
  label?: string;
  title?: string;
  children: ReactNode;
}) {
  return (
    <section id={id} className="scroll-mt-16 py-10 first:pt-8 md:scroll-mt-6">
      {title && id in SLIP ? (
        <h2 className="text-[clamp(22px,4.4vw,42px)] leading-[1.35] text-amber">
          <Slip k={id as SlipKey} />
        </h2>
      ) : title ? (
        <h2 className="speedcut font-display font-black text-[clamp(17px,3.4vw,32px)] uppercase leading-[1.35] tracking-[0.04em] text-amber">
          {title}
        </h2>
      ) : null}
      {children}
    </section>
  );
}
